/* eslint import/no-webpack-loader-syntax: 0, import/no-unresolved: 0 */
var amazed = '//assets.podium.com/icons/dolphins/amazed.svg';
var angry = '//assets.podium.com/icons/dolphins/angry.svg';
var concerned = '//assets.podium.com/icons/dolphins/concerned.svg';
var confused = '//assets.podium.com/icons/dolphins/confused.svg';
var excited = '//assets.podium.com/icons/dolphins/excited.svg';
var excitedGreyBackground = '//assets.podium.com/icons/dolphins/excitedGreyBackground.svg';
var happy = '//assets.podium.com/icons/dolphins/happy.svg';
var paranoid = '//assets.podium.com/icons/dolphins/paranoid.svg';
var waiting = '//assets.podium.com/icons/dolphins/waiting.svg';
export default {
  amazed: amazed,
  angry: angry,
  concerned: concerned,
  confused: confused,
  excited: excited,
  excitedGreyBackground: excitedGreyBackground,
  happy: happy,
  paranoid: paranoid,
  waiting: waiting
};